import React from 'react';
import './Settings.scss';

function Settings() {
  return (
    <div className="settings-page">
      <h1>Account Settings</h1>
      <p>Manage your account details and preferences.</p>
      
      <div className="settings-content">
        <div className="card">
          <div className="card-header">
            <h3>Profile Information</h3>
          </div>
          <div className="card-body">
            <form className="settings-form">
              <div className="form-group">
                <label htmlFor="fullName">Full Name</label>
                <input type="text" id="fullName" placeholder="John Doe" />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input type="email" id="email" placeholder="john@example.com" />
              </div>
              
              <div className="form-group">
                <label htmlFor="company">Company Name (Optional)</label>
                <input type="text" id="company" placeholder="Your Company" />
              </div>
              
              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input type="tel" id="phone" placeholder="+1 (555) 123-4567" />
              </div>
              
              <div className="form-actions">
                <button type="submit" className="btn btn-primary">Save Changes</button>
              </div>
            </form>
          </div>
        </div>
        
        <div className="card mt-4">
          <div className="card-header">
            <h3>Change Password</h3>
          </div>
          <div className="card-body">
            <form className="settings-form">
              <div className="form-group">
                <label htmlFor="currentPassword">Current Password</label>
                <input type="password" id="currentPassword" />
              </div>
              
              <div className="form-group">
                <label htmlFor="newPassword">New Password</label>
                <input type="password" id="newPassword" />
              </div>
              
              <div className="form-group">
                <label htmlFor="confirmPassword">Confirm New Password</label>
                <input type="password" id="confirmPassword" />
              </div>
              
              <div className="form-actions">
                <button type="submit" className="btn btn-primary">Update Password</button>
              </div>
            </form>
          </div>
        </div>
        
        <div className="card mt-4">
          <div className="card-header">
            <h3>Notification Preferences</h3>
          </div>
          <div className="card-body">
            <form className="settings-form">
              <div className="form-check">
                <input type="checkbox" id="emailNotifications" checked />
                <label htmlFor="emailNotifications">Email Notifications</label>
              </div>
              
              <div className="form-check">
                <input type="checkbox" id="invoiceAlerts" checked />
                <label htmlFor="invoiceAlerts">Invoice and Payment Alerts</label>
              </div>
              
              <div className="form-check">
                <input type="checkbox" id="serviceUpdates" checked />
                <label htmlFor="serviceUpdates">Service Updates</label>
              </div>
              
              <div className="form-check">
                <input type="checkbox" id="marketingEmails" />
                <label htmlFor="marketingEmails">Marketing and Promotional Emails</label>
              </div>
              
              <div className="form-actions">
                <button type="submit" className="btn btn-primary">Save Preferences</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Settings; 